<div class="mi-hamburger">

    <button class="mi-hamburger-button" (click)="toggleMenu()" [attr.aria-expanded]="sidebarVisible"
        [attr.aria-label]="menuText?.menu" [attr.aria-controls]="'mi-navigation-menu'">
        <div class="mi-hamburger-button-icon-line"></div>
        <div class="mi-hamburger-button-icon-line"></div>
        <div class="mi-hamburger-button-icon-line"></div>
    </button>

    <nav id="mi-navigation-menu" class="mi-navigation-menu" [class.open]="sidebarVisible"
        [class.close]="!sidebarVisible">


        <ul>
            <li>
                <div class="mi-navigation-menu-item h-3 d-flex justify-content-end align-items-center">


                    <mc-button class="mc-transparent-button" [label]="'X'" [ariaLabel]="menuText?.close"
                        (click)="closeMenu()" [id]="'mi-transparent-button'"></mc-button>


                </div>
            </li>
            <li>
                <div class="mi-navigation-menu-item-section">
                    <div class="h-3 mi-navigation-menu-item d-flex justify-content-between align-items-center">
                        <mc-button class="mc-transparent-button" [attr.aria-expanded]="!isCloseLanguage"
                            [icon]="'icon-Color-Overlay  cursor-pointer fw-bolder'" (click)="toggleLanguage()"
                            [ngClass]="{'close-i': !isCloseLanguage}" (keyup.enter)="toggleLanguage()"
                            [label]="menuText?.languages.selectedLanguage"
                            [ariaLabel]="menuText?.languages.selectedLanguage" [ariaExpanded]="!isCloseLanguage"
                            [ariaControls]="'mi-navigation-menu-item-section-content'"></mc-button>

                    </div>
                    @if(!isCloseLanguage){


                    <div class="mi-navigation-menu-item-section-content">
                        <div class="h-3 d-flex align-items-center">
                            <mc-button class="mc-transparent-button" [label]="menuText?.languages.hebrew"
                                [ariaLabel]="menuText?.languages.hebrew"></mc-button>
                        </div>
                        <!-- <div class="h-3  fw-bold">
                            <span>
                                אנגלית
                            </span>
                        </div>
                        <div class="h-3 ">
                            <span>
                                ערבית
                            </span>
                        </div> -->
                    </div>
                    }
                </div>

            </li>
            <li>
                <div class="mi-navigation-menu-item-section">
                    <div class="h-3 mi-navigation-menu-item d-flex justify-content-between align-items-center">
                        <mc-button class="mc-transparent-button" [attr.aria-expanded]="!isCloseHelpInformation"
                            [icon]="'icon-Color-Overlay  cursor-pointer fw-bolder'" (click)="toggleHelpInformation()"
                            [ngClass]="{'close-i': !isCloseHelpInformation}" (keyup.enter)="toggleHelpInformation()"
                            [label]="menuText?.helpAndInfo" [ariaLabel]="menuText?.helpAndInfo"
                            [ariaExpanded]="!isCloseHelpInformation"></mc-button>
                    </div>
                </div>
            </li>
            <li>
                <div class="mi-navigation-menu-item-section">
                    <div class="h-3 mi-navigation-menu-item d-flex justify-content-between  align-items-center">
                        <a href="tel:1299" id="mi-call-to-gov">
                            <span class="mi-call-to-gov-text"> {{menuText?.callToGov}} </span>
                            <i class="icon-phone-call-1" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </li>
        </ul>



    </nav>

</div>